import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

interface IntroductionSectionProps {
  introduction: string;
  mission: string;
}

const IntroductionSection = ({ introduction, mission }: IntroductionSectionProps) => {
  const { t } = useTranslation();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="max-w-4xl mx-auto text-center mb-16"
    >
      <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
        {t('about.sections.aboutMe')}
      </h1>
      <p className="text-lg md:text-xl text-white/70 mb-8 leading-relaxed">
        {introduction}
      </p>
      <div className="glass-card rounded-2xl p-8">
        <h2 className="text-2xl font-semibold text-accent mb-4">
          {t('about.missionTitle')}
        </h2>
        <p className="text-white/65 leading-relaxed">
          {mission}
        </p>
      </div>
    </motion.div>
  );
};

export default IntroductionSection;